import React, { createContext, useState } from 'react'

export const Likecontext = createContext(null)

export const Provider = ({ children }) => {
  const [value, setValue] = useState(null)

  return (
    <Likecontext.Provider
      value={{
        value,
        setValue,
      }}
    >
      {children}
    </Likecontext.Provider>
  )
}
